const RequestTwoRecommendationsMock = (props) => {
  return {
    first: {
      imdb_id: 119698,
      poster_link:
        "https://static.wikia.nocookie.net/studio-ghibli/images/c/c6/Princess_Mononoke.jpg/",
      trailer_link: "",
      title: "Princess Mononoke",
      serie: 0,
      genres: [15, 34],
      year: 1997,
      fsk: 12,
      provider: "Netflix",
      url: "https://www.netflix.com/de/title/28630857",
    },
    second: {
      imdb_id: 3880990,
      poster_link:
        "https://m.media-amazon.com/images/M/MV5BMjI3Mjg0MjI5OF5BMl5BanBnXkFtZTgwNzE1MjAwNjE@._V1_FMjpg_UX1000_.jpg",
      trailer_link: "",
      title: "Long March to Freedom",
      serie: 0,
      genres: [91, 40, 55, 31, 11, 281],
      year: 2011,
      fsk: 12,
      provider: "Netflix",
      url: "https://www.netflix.com/de/title/81493708",
    },
  };
};

export default RequestTwoRecommendationsMock;
